import { IIndexable } from 'core-ts-types';
import { merge } from 'lodash4';
import { ITreeNode } from 'utility-ts-type';
import { TimeUtility } from 'utility-ts-type';
import { APTerm } from './ap_term_builder';
export class PlannedTerm implements IIndexable, ITreeNode {
  id: number;
  term: Partial<APTerm>;

  constructor(plannedTerm: PlannedTerm) {
    merge(plannedTerm.term, {
      registration_start_dt: TimeUtility.parseYearMonthDay(plannedTerm.term.registration_start_dt as moment.Moment),
      registration_end_dt: TimeUtility.parseYearMonthDay(plannedTerm.term.registration_end_dt as moment.Moment),
      term_start_dt: TimeUtility.parseYearMonthDay(plannedTerm.term.term_start_dt as moment.Moment),
      term_end_dt: TimeUtility.parseYearMonthDay(plannedTerm.term.term_end_dt as moment.Moment)
    });

    merge(this, plannedTerm);
  }

  static build(block: PlannedTerm): PlannedTerm {
    return new PlannedTerm(block);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/planned_term_builder.ts